export default "__VITE_ASSET__33d8a3fe__"